import React from 'react';
import classNames from 'classnames';
import './ListItem.scss';

type ListItemProps = {
  title?: string;
  text?: string;
  action?: () => void;
  active?: boolean;
};

export const ListItem = ({ title, text, action, active }: ListItemProps) => {
  return (
    <div
      className={classNames('c-list-item-container', {
        'c-list-item-container--active': active,
      })}
      onClick={action}
    >
      <p className='c-list-item-title'>{title}</p>
      {text && <p className='c-list-item-text'>{text}</p>}
    </div>
  );
};
